import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@apollo/client/react";
import moment from "moment";
import { Tooltip, Typography } from "@mui/material";
import { GET_SCRAPPER_LIST } from "@/hooks";

export const ScraperList = () => {
  // const [scrapperData, setScrapperData] = useState([]);
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const { data: scrapperDataList, loading } = useQuery<any>(GET_SCRAPPER_LIST, {
    variables: {},
  });
  interface ScrapperInfoItem {
    scrapperName?: string;
    status?: string;
    createdAt?: string;
    url?: string;
    description?: string;
  }

  interface ScraperRow {
    id: number;
    scrapperName?: string;
    status?: string;
    createdAt?: string;
    url?: string;
    description?: string;
  }

  const scrapperData = useMemo<ScraperRow[]>(() => {
    let returnData: ScraperRow[] = [];
    if (!loading && scrapperDataList) {
      const { scrapperInfo } = scrapperDataList as any;
      const list: ScraperRow[] = [];
      (scrapperInfo || []).forEach((item: ScrapperInfoItem, index: number) => {
        list.push({
          id: index + 1,
          scrapperName: item.scrapperName,
          status: item.status,
          createdAt: item.createdAt,
          url: item.url,
          description: item.description,
        });
      });

      returnData = list;
    }
    return returnData;
  }, [scrapperDataList, loading]);

  /**
   *
   * @param row
   */
  function columnFormater(row: ScraperRow) {
    return (
      <Tooltip title={row?.description} arrow>
        <Typography noWrap>{row?.description}</Typography>
      </Tooltip>
    );
  }

  const columns = [
    {
      field: "id",
      headerName: gettext("ID"),
      flex: 0.5,
      headerAlign: "left",
    },
    {
      field: "scrapperName",
      headerName: gettext("Scraper Name"),
      flex: 2,
      headerAlign: "left",
    },
    {
      field: "url",
      headerName: gettext("URL"),
      flex: 2,
      headerAlign: "left",
    },
    {
      field: "description",
      headerName: gettext("Description"),
      flex: 3,
      headerAlign: "left",
      renderCell: (params: { row?: ScraperRow }) =>
        columnFormater(params?.row as ScraperRow),
    },
    {
      field: "status",
      headerName: gettext("Status"),
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "createdAt",
      headerName: gettext("Created At"),
      flex: 1,
      headerAlign: "left",
      valueFormatter: (params: { value?: any; row?: ScraperRow }) =>
        moment(params.row?.createdAt || params.value).format(
          "DD/MM/YYYY HH:MM",
        ),
    },
    // {
    //   field: "lastRun",
    //   headerName: gettext("Last Run"),
    //   flex: 1,
    //   headerAlign: "left"
    // }
  ];

  return (
    <>
      <div className="card card-custom gutter-b example example-compact">
        <div className="table-div m-0">
          <div className="table-title">
            <h3>{gettext("Scraper List")}</h3>
          </div>
          <div className="card-body">
            <div
              style={{
                width: "100%",
              }}
            >
              <DataGrid
                rows={scrapperData}
                columns={columns as any}
                initialState={{
                  pagination: { paginationModel: { pageSize: 100, page: 0 } },
                }}
                pageSizeOptions={[5, 10, 50, 100]}
                autoHeight
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
